import Div from "@jumbo/shared/Div/Div";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import "./PreviewFormSelected.css";

const PreviewFormsSelected = ({upperSectionProps, lowerSectionProps, setSelectedForm}) => {
    const [upperSelectedItems, setUpperSelectedItems] = useState(upperSectionProps.selectedItem);
    const [lowerSelectedItems, setLowerSelectedItems] = useState(lowerSectionProps?.selectedItem);

    // Update component when selectedForm changes
    useEffect(() => {
        setUpperSelectedItems(upperSectionProps.selectedItem);
    }, [upperSectionProps.selectedItem]);

    return (
        <Div className="pfs-wrapper">
            <Div
                sx={{
                    maxHeight: lowerSectionProps ? "50% !important" : "100% !important",
                    height: "auto"
                }}
                className="pfs-wrapper-1 pfs-wrapper-item"
            >
                <div className="heading-area">
                    <Typography
                        component="h4"
                        sx={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            padding: "10px"
                        }}
                    >
                        {upperSectionProps.title}
                    </Typography>
                </div>
                <div className="pfs-area customize-scrollbar">
                    {
                        // selectedItems CONTAINS THE LIST OF THE SELECTED ROWS
                        upperSectionProps.selectedItems?.map((item, index) => {
                            return (
                                <Button
                                    key={item.id}
                                    className={`customize-chip text-center ${
                                        // To set the color to green by passing a class
                                        upperSectionProps?.setColor ? upperSectionProps?.setColor : ""
                                    } ${upperSelectedItems === item.id ? "selected" : ""}`}
                                    onClick={() => {
                                        setUpperSelectedItems(upperSectionProps.selectedItems[index].id);
                                        setSelectedForm(upperSectionProps.selectedItems[index].id);
                                    }}
                                >
                                    {item.form_code}
                                </Button>
                            );
                        })
                    }
                </div>
            </Div>
            {lowerSectionProps && (
                <Div
                    sx={{
                        maxHeight: "50% !important",
                        height: "auto"
                    }}
                    className="pfs-wrapper-2 pfs-wrapper-item"
                >
                    <div className="heading-area">
                        <Typography
                            component="h4"
                            sx={{
                                fontSize: "16px",
                                fontWeight: "500",
                                textAlign: "center",
                                padding: "10px"
                            }}
                        >
                            {lowerSectionProps.title}
                        </Typography>
                    </div>
                    <div className="pfs-area customize-scrollbar">
                        {lowerSectionProps?.selectedItems?.map((item, index) => {
                            return (
                                <Button
                                    key={item.id}
                                    className={`customize-chip orange-chip text-center ${lowerSelectedItems === item.id ? "selected" : ""}`}
                                    label={item.title}
                                    onClick={() => setLowerSelectedItems(upperSectionProps.selectedItems[index].id)}
                                >
                                    {item.title}
                                </Button>
                            );
                        })}
                    </div>
                </Div>
            )}
        </Div>
    );
};

export default PreviewFormsSelected;